import React from 'react';
import styles from '../../Invoicing.module.css';
import { CheckIcon } from '../../icons';

const FeatureBlocks = () => (
  <>
    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={styles.feature}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />Branded &amp; professional</span>
            <h2>Invoices that look like you.</h2>
            <p>Add your logo and brand colors, drag and drop line items, and send something that looks polished every time. Create an invoice once, then duplicate it whenever you need it again.</p>
            <ul className={styles.fList}>
              {['Your logo and brand colors', 'Drag-and-drop line items', 'Create once, duplicate anytime', 'Add a custom message or notes'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop}>
              <div><div className={styles.invLab}>INVOICE</div><div className={styles.invNum}>#1044 · Draft</div></div>
              <span className={styles.invStatus}>Editing</span>
            </div>
            <div className={styles.invRow}><span>Consulting — June</span><span className={styles.mono}>$2,500.00</span></div>
            <div className={styles.invRow}><span>Workshop facilitation</span><span className={styles.mono}>$800.00</span></div>
            <div className={styles.invRow}><span>Travel</span><span className={styles.mono}>$180.00</span></div>
            <div className={styles.invTotal}><span>Total</span><span className={styles.mono}>$3,480.00</span></div>
            <div className={styles.invPaynow}>Send invoice →</div>
          </div>
        </div>
      </div>
    </section>

    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={`${styles.feature} ${styles.featureFlip}`}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />Online payments</span>
            <h2>A Pay Now button on every invoice.</h2>
            <p>The moment your customer opens the invoice, they can pay in a tap — with whatever&apos;s easiest for them. Repeat clients can save a payment method for next time.</p>
            <ul className={styles.fList}>
              {['Fyntiq Wallet, with same-day payout to you', 'Card, Apple Pay, Google Pay & Cash App Pay', 'Bank transfer for larger amounts', 'Saved methods for repeat customers'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop} style={{ border: 'none', paddingBottom: 8 }}>
              <div className={styles.invNum} style={{ fontSize: 14 }}>Choose how to pay</div>
              <span className={styles.invLab}>$1,240.00</span>
            </div>
            <div className={styles.pcMethods}>
              <div className={`${styles.pcM} ${styles.pcMSel}`}>
                <span className={styles.ic}>
                  <svg viewBox="0 0 24 24" width="18" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="7" width="18" height="12" rx="2" /><path d="M3 11h18" /></svg>
                </span>
                Wallet
              </div>
              <div className={styles.pcM}>
                <span className={styles.ic}>
                  <svg viewBox="0 0 24 24" width="18" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 10h18" /></svg>
                </span>
                Card
              </div>
              <div className={styles.pcM}>
                <span className={styles.ic}>
                  <svg viewBox="0 0 24 24" width="18" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 21h18M5 21V10M19 21V10M3 10l9-6 9 6" /></svg>
                </span>
                Bank
              </div>
              <div className={styles.pcM}>
                <span className={styles.ic}>
                  <svg viewBox="0 0 24 24" width="18" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
                </span>
                Finance
              </div>
            </div>
            <button type="button" className={styles.pcPay}>Pay $1,240.00 →</button>
          </div>
        </div>
      </div>
    </section>

    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={styles.feature}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />Accounts receivable</span>
            <h2>Always know who owes you.</h2>
            <p>See every invoice at a glance — paid, due, or overdue. Filter by status, hover for the details, and let automatic receipts keep your records tidy at tax time.</p>
            <ul className={styles.fList}>
              {['Filter by invoice status', 'Automatic receipts on every payment', 'Payment reminders that send themselves', 'Records ready for tax time'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop} style={{ border: 'none', paddingBottom: 6 }}>
              <div className={styles.invNum} style={{ fontSize: 14 }}>Invoices</div>
              <span className={styles.invLab}>THIS MONTH</span>
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOn}`} />
              <div className={styles.recFlex}><div className={styles.recName}>#1043 · Northbeam</div><div className={styles.recMeta}>Paid · Apr 22</div></div>
              <span className={styles.recAmt}>$1,240</span>
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOn}`} />
              <div className={styles.recFlex}><div className={styles.recName}>#1042 · Bloom Co</div><div className={styles.recMeta}>Paid · Apr 18</div></div>
              <span className={styles.recAmt}>$49</span>
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOff}`} />
              <div className={styles.recFlex}><div className={styles.recName}>#1044 · Acme</div><div className={`${styles.recMeta} ${styles.recMetaDue}`}>Due in 3 days</div></div>
              <span className={styles.recAmt}>$3,480</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default FeatureBlocks;
